import {
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Grid
} from '@mui/material'
import React from 'react'

const BreathSounds = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
      <Autocomplete
        options={[
          'Clear',
          'Fine Crackles',
          'Coarse Crackles',
          'Inspiratory Wheeze',
          'Expiratory Wheeze',
          'Stridor',
          'Absent Breath Sounds',
          'Pleural Rub',
        ]}
        value={moduleValues?.['Breath Sounds'] ?? []}
        onChange={(e, value) =>
          setModuleValues((prev) => ({ ...prev, ['Breath Sounds']: value }))
        }
        renderInput={(params) => (
          <TextField {...params} label="Breath Sounds" />
        )}
        multiple
        freeSolo
      />
  </Grid>
)

export default BreathSounds
